import { Button, Loading, Modal } from '@orobix/orobix-fe-components'
import { Trans, useTranslation } from 'react-i18next'

import {
  getIsExceeded,
  getQuota,
  getRemaining,
  getStatus,
  getUsed,
} from '../../../utils/counter'
import useStyles from './StartTrainingConfirmationModal.styles'
import { useTrainingCounterData } from './useTrainingCounterData'

export interface StartTrainingConfirmationModalProps {
  onCloseRequest: () => void
  onStartTrainingRequest: () => void
}

export const StartTrainingConfirmationModal = ({
  onCloseRequest,
  onStartTrainingRequest,
}: StartTrainingConfirmationModalProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { counter } = useTrainingCounterData()

  const remaining = getRemaining(counter)
  const used = getUsed(counter)
  const quota = getQuota(counter)
  const isExceeded = getIsExceeded(counter)

  const handleClick = () => {
    onCloseRequest()
    onStartTrainingRequest()
  }

  return (
    <Modal
      size="sm"
      onCloseRequest={onCloseRequest}
      title={t('Confirm training')}
      footer={
        counter ? (
          <>
            <Button
              onClick={onCloseRequest}
              label={t('Cancel')}
              type="default"
              buttonType="button"
            />
            <Button
              onClick={handleClick}
              label={t('Start training')}
              type="action"
              buttonType="button"
              disabled={counter.isEnabled && isExceeded}
            />
          </>
        ) : null
      }
    >
      {
        {
          allowed: (
            <Trans
              i18nKey="You have only <emph>{{ count }} training left</emph> ({{ used }} used over {{ quota }} available). Are you sure you want to proceed?"
              values={{ count: remaining, quota, used }}
              components={{ emph: <b className={classes.emph} /> }}
            />
          ),
          forbidden: t('Sorry, you reached maximum training limit.'),
          disabled: t('Great, you have unlimited trainings.'),
          loading: <Loading />,
        }[getStatus(counter)]
      }
    </Modal>
  )
}

export default StartTrainingConfirmationModal
